import React from "react";
import { Input, Select } from "@pd/pd-ui-kit";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormField from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/sections/FormField";
import Status from "~/pages/BaseStaff/ViewingBaseStaff/ui/Status";
import { getFormatDate } from "~/libs/getFormatDate";
import { TDealerFormItem } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";
import { StatusSelectOptions } from "~/pages/BaseStaff/options";
import { FileFieldController } from "~/shared/ui/Fields/FileField";

import { IDealerRowProps, TUploadDocumentFn } from "./types";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IStatusFieldsRowProps extends IDealerRowProps {
  employeeId: string;
  isNewPosition: boolean;
  refetch?: () => void;
  dealerData?: TDealerFormItem;
  directionRole?: string[];
  directionId?: string;
  disabled?: boolean;
  showJobDescription: boolean;
  uploadJobDescription?: TUploadDocumentFn;
}

const StatusFieldsRow = ({
  control,
  dealerPrefix,
  employeeId,
  isNewPosition,
  refetch,
  dealerData,
  directionRole,
  directionId,
  disabled,
  showJobDescription,
  uploadJobDescription,
}: IStatusFieldsRowProps) => {
  const { t } = useTranslation();

  return (
    <div className={s.grid4}>
      <FormField label={t("employee.status")}>
        {dealerData?.employeePositionId && !isNewPosition ? (
          <Status
            asField
            refetch={refetch}
            statusValue={StatusSelectOptions.find(
              (option) => option.value === dealerData.status,
            )}
            EmployeeId={employeeId}
            positionId={String(dealerData.instanceId || "")}
            allowedRolesForEditing={directionRole || []}
            instanceId={directionId}
          />
        ) : (
          <Select
            value={dealerData?.status || undefined}
            placeholder={t("ui.select")}
            options={StatusSelectOptions}
            disabled
          />
        )}
      </FormField>

      <FormField label={t("employee.lastStatusUpdateAt")}>
        <Controller
          name={`${dealerPrefix}.lastStatusUpdateAt`}
          control={control}
          render={({ value }) => (
            <Input value={value ? getFormatDate(value, true) : "—"} disabled />
          )}
        />
      </FormField>

      <FormField label={t("employee.whoLastStatusUpdateByUser")}>
        <Controller
          name={`${dealerPrefix}.lastStatusUpdateByUser`}
          control={control}
          render={({ value }) => <Input value={value || "—"} disabled />}
        />
      </FormField>

      {showJobDescription && (
        <FormField label={t("employee.jobDescription")}>
          <FileFieldController
            name={`${dealerPrefix}.jobDescriptionId`}
            control={control}
            accept=".pdf,.jpg,.jpeg,.png"
            maxSizeMb={5}
            disabled={disabled}
            uploadFn={uploadJobDescription}
            initialFile={
              dealerData?.jobDescription
                ? {
                    id: dealerData.jobDescription.id,
                    name:
                      dealerData.jobDescription.name ||
                      t("employee.jobDescription"),
                    link: dealerData.jobDescription.link || "",
                  }
                : null
            }
          />
        </FormField>
      )}
    </div>
  );
};

export default StatusFieldsRow;
